import {WorkshopScope} from './types'

/** @public */
export function defineScope(scope: WorkshopScope): WorkshopScope {
  return scope
}
